export default "__VITE_ASSET__Ayq4nmA3__"